export const GET_INVESTOR_INVITES_SUCCESS = 'GET_INVESTOR_INVITES_SUCCESS';
export const SET_INVESTOR_INVITES_LOADING = 'SET_INVESTOR_INVITES_LOADING';
